"use client";

/**
 * One panel, drawn (composer panels, spec 2026-09-19 §3.4): the switch every
 * host renders through, so the pill, the inline card and the crown can never
 * draw a kind differently. history and tray are the host's store actions,
 * or a words line where the host has no history and no tray (the task page);
 * close never stays; connect draws the paused agent's own card (2026-09-22)
 * and confirm is still Train 2 (spec §7), rendering nothing rather than a
 * wrong card.
 */
import type { ComposerPanel, ComposerUndoResponse } from "@bash/shared";
import { ConnectPanel } from "./ConnectPanel";
import { ReceiptPanel } from "./ReceiptPanel";
import { SheetPanel } from "./SheetPanel";

export interface PanelCardProps {
  panel: ComposerPanel;
  onClose: () => void;
  onOpen: (route: string) => void;
  onUndo: (runId: string) => Promise<ComposerUndoResponse>;
  /** The host has no history and no tray: print their words instead. */
  words?: boolean;
}

export function PanelCard({
  panel,
  onClose,
  onOpen,
  onUndo,
  words,
}: PanelCardProps) {
  switch (panel.kind) {
    case "sheet":
      return <SheetPanel panel={panel} onClose={onClose} onOpen={onOpen} />;
    case "receipt":
      return <ReceiptPanel panel={panel} onClose={onClose} onUndo={onUndo} />;
    case "connect":
      return <ConnectPanel panel={panel} onClose={onClose} />;
    case "history":
    case "tray":
      return words ? (
        <div className="text-3.5 text-fg-muted" data-testid="panel-words">
          {panel.words}
        </div>
      ) : null;
    default:
      return null;
  }
}
